import { CONSTANT_TABLE } from '@/components/Table/list-table/interface';
import { path } from '@/routes/paths';
import { translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import { Chip } from '@mui/material';

export const TABLE_HEAD_PRODUCTS: CONSTANT_TABLE[] = [
  { id: 'product.id', label: 'ID', align: 'left' },
  { id: 'product.name', label: translates.name, align: 'left' },
  { id: 'product.description', label: translates.description, align: 'center' },
  {
    id: 'subtotal',
    label: translates.cost,
    align: 'center',
    wrapComponent: (value: number) => currentFormat(value),
  },
  {
    id: 'sellLetter',
    label: translates.sellPrice,
    align: 'center',
    wrapComponent: (value: number) => currentFormat(value),
  },
  { id: 'categories.name', label: translates.categories, align: 'center' },
  { id: 'lines.name', label: translates.lines, align: 'center' },
  {
    id: 'product.status',
    label: translates.status,
    align: 'center',
    wrapComponent: (value: boolean) => (
      <Chip
        color={value ? 'success' : 'error'}
        label={value ? translates.active : translates.disable}
      />
    ),
  },
  { id: '', disableSort: true },
];

export const STATUS_OPTIONS = [
  { value: 'Activo', label: translates.active },
  { value: 'Desactivado', label: translates.disabled },
];

export const PATH_RESERVATION = (ROOTS_DASHBOARD: string) => ({
  root: path(ROOTS_DASHBOARD, '/products'),
  list: path(ROOTS_DASHBOARD, '/products/list'),
  view: (name: number) => path(ROOTS_DASHBOARD, `/products/${name}`),
  edit: (name: number) => path(ROOTS_DASHBOARD, `/products/${name}/edit`),
});
